<template>
  <el-dropdown
    @visible-change="toggle"
    @command="changeCurrency"
    popperClass="currency"
    placement="bottom"
    width="200"
    trigger="click"
  >
    <strong class="el-dropdown-link flat" :class="{ 'is-active': open }"
      ><span>{{ currency }}</span></strong
    >
    <el-dropdown-menu slot="dropdown" class="type-header currency-list">
      <strong class="menu-title">{{ $t('common.title.changeCurrency') }}</strong>
      <div class="menu-wrap">
        <el-dropdown-item
          v-for="(curr, index) in currencies"
          :key="index"
          :command="curr.toUpperCase()"
          :class="{ 'is-active': curr == currency }"
        >
          {{ $t('common.currency.' + curr) }} <span>({{ curr }})</span>
        </el-dropdown-item>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getCookie, setCookie } from '@/util/methods'

export default {
  data() {
    return {
      open: false,
    }
  },
  computed: {
    ...mapGetters({
      currencies: 'i18n/currencies',
      currency: 'i18n/currency',
    }),
  },
  methods: {
    ...mapActions({
      setCurr: 'i18n/setCurr',
    }),
    changeCurrency(curr) {
      setCookie('currency', curr)
      this.$bar.start()
      location.reload()

      // document.cookie = 'currency=' + curr + '; path=/;'
      // const cookieCurrency = getCookie('currency');
      // if(cookieCurrency) {
      //   this.$store.$http.defaults.headers = _.extend(this.$store.$http.defaults.headers, {
      //     'X-Requested-Currency': cookieCurrency.toUpperCase()
      //   });
      //   this.$store.state.i18n.currency = cookieCurrency;
      // }
      // this.$router.go({
      //   path: this.$route.fullpath,
      //   force: true
      // })
    },
    toggle(appear) {
      this.$emit('opened', appear)
      this.open = appear
    },
  },
}
</script>
